import api from './api';

export const fetchPermissionCatalog = async () => {
  const response = await api.get('/admin/rbac/');
  return response.data;
};

export const fetchUserPermissions = async (userId) => {
  const response = await api.get(`/admin/rbac/users/${userId}/permissions/`);
  return response.data;
};

export const updateUserPermissions = async (userId, payload) => {
  const response = await api.patch(`/admin/rbac/users/${userId}/permissions/`, payload);
  return response.data;
};

export const fetchRoles = async (params = {}) => {
  const response = await api.get('/admin/rbac-roles/', { params });
  return response.data;
};

export const fetchRole = async (roleId) => {
  const response = await api.get(`/admin/rbac-roles/${roleId}/`);
  return response.data;
};

export const createRole = async (data) => {
  const response = await api.post('/admin/rbac-roles/', data);
  return response.data;
};

export const updateRole = async (roleId, data) => {
  const response = await api.put(`/admin/rbac-roles/${roleId}/`, data);
  return response.data;
};

export const deleteRole = async (roleId) => {
  await api.delete(`/admin/rbac-roles/${roleId}/`);
  return true;
};


